module.exports = __webpack_public_path__ + "img/about-image.e78bcbf0.png";